import React from 'react';
import cn from 'classnames';
import { Form, Localization } from 'connex-cds';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { useTicketContext } from '../../../../TicketContext';
import { FLOW } from '../Acceptance';
import style from './style';

const Styled = styled.div`
  ${style}
`;

export const HeaderMobile = ({ flow, submitAcceptanceVisible, signed, entitySupportedLanguages, errors }) => {
  const {
    Components: { SubmitButton },
  } = Form.useFormContext();

  const { submitted, ticket } = useTicketContext();
  const leftJustify = signed || submitAcceptanceVisible;

  return (
    <Styled className={cn('header-mobile-aceptance')}>
      <div className={cn('left-side')}>
        {leftJustify ? (
          <Localization.LocaleSwitcher persist={false} entitySupportedLanguages={entitySupportedLanguages} />
        ) : null}
      </div>
      <div className={cn('right-side')}>
        {leftJustify ? null : (
          <Localization.LocaleSwitcher persist={false} entitySupportedLanguages={entitySupportedLanguages} />
        )}
        {flow === FLOW.ACCEPT_REJECT || (flow === FLOW.SIGNATURE_NO_SIGNATURE && submitAcceptanceVisible) ? (
          <SubmitButton
            stringId={
              ticket?.customerStatus?.statusCode === 'REJECTED'
                ? 'rejected'
                : submitted
                ? 'accepted'
                : 'submitAcceptance'
            }
            data-testid="submit-acceptance-button"
            disabledWhenNotDirty={false}
            disabled={submitted || !isEmpty(errors)}
          />
        ) : null}
      </div>
    </Styled>
  );
};
